import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-flexa';
import { withStyles } from '@material-ui/core/styles';
import { imageRoot } from '../../../env.config';
import LeadContainer from './Lead';
import ImageSlider from '../../components/ImageSlider/ImageSlider';

const styles = theme => ({
  root: {
    background: `url(${imageRoot}/pricingpage/lead_background.jpg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    height: '100%',
    position: 'relative',
    padding: '0.5rem'
  },

  rightRoot: {
    textAlign: 'center',
    padding: '3rem 1rem',
    maxWidth: '100%',
    [theme.breakpoints.down(426)]: {
      padding: '1rem 0 1rem 0'
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
      maxWidth: '65%'
    },
    [theme.breakpoints.down('lg')]: {
      margin: 'auto'
    }
  },
  topSection: {
    maxWidth: 1343,
    margin: '0 auto'
  },
  divider: {
    border: `1px solid #dadada`,
    width: 0,
    height: '90%',
    margin: 'auto'
  }
});

const TopSliderImages = [
  '/pricingpage/slider-images/top-slider/Slide_1-Bar Cabinet@2x.png',
  '/pricingpage/slider-images/top-slider/Slide_1-Bent Table@2x.png',
  '/pricingpage/slider-images/top-slider/Slide_1-Range@2x.png'
];

class TopSection extends React.Component {
  render() {
    const {
      classes,
      handleScrollToPricing,
      handleScrollToComparison
    } = this.props;
    return (
      <div className={classes.root}>
        <Row className={classes.topSection} gutter={0}>
          <Col xs={12} sm={12} md={4}>
            <LeadContainer
              callbackPricing={handleScrollToPricing}
              callbackComparison={handleScrollToComparison}
            />
          </Col>
          <Col xs={12} sm={12} md={8}>
            <div className={`${classes.rightRoot} padding-xs`}>
              <ImageSlider images={TopSliderImages} />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

TopSection.propTypes = {
  classes: PropTypes.object.isRequired,
  handleScrollToPricing: PropTypes.func.isRequired,
  handleScrollToComparison: PropTypes.func.isRequired
};

export default withStyles(styles)(TopSection);
